/**
 * Based on https://github.com/uswds/uswds/blob/develop/src/components/pagination/pagination.config.yml
 */

export interface PaginationLabels {
  ariaLabel: string;
  pageLabel: string;
  previousLabel: string;
  nextLabel: string;
  lastItemLabel: string;
}

export interface Translations {
  en: {
    default: PaginationLabels;
    unbounded: PaginationLabels;
  };
  es: {
    default: PaginationLabels;
    unbounded: PaginationLabels;
  };
}

const translations: Translations = {
  en: {
    default: {
      ariaLabel: 'Pagination',
      pageLabel: 'Page',
      previousLabel: 'Previous',
      nextLabel: 'Next',
      lastItemLabel: 'Last page,',
    },
    unbounded: {
      ariaLabel: 'Pagination',
      pageLabel: 'Page',
      previousLabel: 'Previous',
      nextLabel: 'Next',
      lastItemLabel: 'Last page,',
    },
  },
  es: {
    default: {
      ariaLabel: 'Paginación',
      pageLabel: 'Página',
      previousLabel: 'Anterior',
      nextLabel: 'Siguiente',
      lastItemLabel: 'Última página,',
    },
    unbounded: {
      ariaLabel: 'Paginación',
      pageLabel: 'Página',
      previousLabel: 'Anterior',
      nextLabel: 'Siguiente',
      lastItemLabel: 'Última página,',
    },
  },
};

export default translations;
